<template lang="pug">

  form-group-row(:form="form", :label="label", name="birth_date", required)
    datepicker(v-model="birthDate", name="birth_date", format="MM/dd/yyyy", initial-view="year", input-class="form-control", :class="{'is-invalid': form.errors.has('birth_date')}")

</template>

<script>

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'user-input-birth-date',

  components: {
    Datepicker,
  },

  props: {
    label: {
      type: String,
      default: 'Birth date',
    },
  },

  data: () => ({
    form: null,
    birthDate: null,
  }),

  watch: {
    birthDate(val) {
      this.form.birth_date = val ? moment(val).format('YYYY-MM-DD') : null;
    }
  },

  async created() {
    this.form = this.$parent.form;
    this.form.birth_date = this.$parent.user ? this.$parent.user.meta.birth_date : null;
    this.birthDate = this.form.birth_date;
  },
}

</script>
